'use client';

import { useTranslations } from 'next-intl';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { SearchDialog } from '../SearchDialog/SearchDialog';
import { SearchInput } from '../SearchInput/SearchInput';

type HeaderSearchProps = React.HTMLAttributes<HTMLDivElement> & {
  allowedPage: string;
};

function HeaderSearch({ allowedPage, ...props }: HeaderSearchProps) {
  const t = useTranslations('general.search');
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const pathname = usePathname();

  if (pathname !== allowedPage) {
    return null;
  }

  return (
    <div className="hidden md:flex z-10" {...props}>
      <SearchInput value="" placeholder={t('placeholder')} onFocus={() => setIsSearchOpen(true)} className="h-10 max-w-33" data-testid="header-search-input" />
      <SearchDialog open={isSearchOpen} onOpenChange={setIsSearchOpen} />
    </div>
  );
}

export { HeaderSearch };
